import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faBagShopping, faChartBar, faChevronUp, faDesktop, faEnvelope, faHome, faImage, faMapMarkerAlt, faPaperPlane, faPhone, faRoad, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faGithub, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
library.add(faFacebook, faGithub, faLinkedinIn, faBagShopping, faChartBar, faChevronUp, faDesktop, faEnvelope,  faHome, faImage, faMapMarkerAlt, faPaperPlane, faPhone, faRoad, faBars, faTimes);

// Styles
import './assets/stylesheets/application.scss';

if (process.env.VUE_APP_ENV !== 'production') {
  console.log("Environment:", process.env.VUE_APP_ENV);
}

const app = createApp(App);

app.component('font-awesome-icon', FontAwesomeIcon);

app.use(router).mount('#app');

